import React, { useState } from 'react';

import ic_info from 'assets/images/ic_info.svg';

import { convertCamelCaseToWords, func_validation, isStringTrimNotEmpty } from 'functions';

import  { FormCheckbox } from "components"; 
import { Tooltip } from 'components/informational/Tooltip';

export const permissionColumns = {
    
    // Columns Array
    getColumns,

    // Columns
    getColumns_permissionName,
    getColumns_userGroup,

}

function getColumns(props) {
    const { userGroupList } = props;

    let columns_userGroups = [];
    if (func_validation.isArrayNotEmpty(userGroupList)) {
        columns_userGroups = userGroupList.map((userGroupObj, idx) => {
            let groupName = func_validation.getObjectPropertyValue(userGroupObj, "GroupName");
            let accessorName = "group" + idx;
            return getColumns_userGroup({ ...props, groupName, accessorName, key: idx });
        })
    }
    return [
        getColumns_permissionName(),
        ...columns_userGroups,
    ];
}

function getColumns_permissionName() {
    let columnClassName = "permission-tableColumn-permissionName";

    return {
        headerCellClassName: "permission-tableColumn-permissionName-header " + columnClassName + " ",
        Header: "Description",
        id: "permissionName",
        accessor: "permissionName",
        sticky: 'left',
        isWidthResizingDisabled: true,
        bodyCellClassName: columnClassName + " ",
        Cell: (cellProps) => {
            let row = func_validation.getObjectPropertyValue(cellProps, "row");
            let rowIdx = func_validation.getObjectPropertyValue(row, "index");
            let depth = func_validation.getObjectPropertyValue(row, "depth");
            let isSubrow = (depth > 0);
            
            let value = func_validation.getObjectPropertyValue(cellProps, "value");

            // Check if its string or array
            let userGroupPermissionName = "";
            let permissionList = [];
            if (func_validation.isStringTrimNotEmpty(value)) {
                userGroupPermissionName = value;
            }
            else if (func_validation.isArrayNotEmpty(value)) {
                permissionList = value.map((permissionDetails, idx) => {
                    return (
                        <div className={"permission-tableColumn-permissionName-subrowItem d-flex align-items-center"} key={idx}>
                            - {convertCamelCaseToWords(permissionDetails?.permissionName)} 

                            {isStringTrimNotEmpty(permissionDetails?.permissionDescription) && (
                                <Tooltip
                                    tooltipContent={permissionDetails?.permissionDescription}
                                    placement={"right"} type={"light"}
                                    target={(
                                        <img className={"permission-tableColumn-permissionName-subrowItem__info-icon"}
                                            src={ic_info}
                                        />
                                    )}
                                />
                            )}
            
                        </div>
                    )
                })
            }

            return (!isSubrow)? (
                <div className={"permission-tableColumn-permissionName-cell d-flex align-items-center"}>
                    {convertCamelCaseToWords(userGroupPermissionName)}
                </div>
            ):(
                <div className={"permission-tableColumn-permissionName-cell-subrow"}>
                    {permissionList}
                </div>
            );
        },
        width: 250,
    }
}

function getColumns_userGroup(props) {
    const { groupName, accessorName, key } = props;

    let columnClassName = "permission-tableColumn-permission";

    return {
        headerCellClassName: "permission-tableColumn-permission-header justify-content-center " + columnClassName + " ",
        Header: groupName,
        id: accessorName,
        accessor: accessorName,
        bodyCellClassName: columnClassName + " ",
        Cell: (cellProps) => {
            let row = func_validation.getObjectPropertyValue(cellProps, "row");
            let rowIdx = func_validation.getObjectPropertyValue(row, "index");
            let depth = func_validation.getObjectPropertyValue(row, "depth");
            let isSubrow = (depth > 0);
            
            let value = func_validation.getObjectPropertyValue(cellProps, "value");
            let userGroupId, isEveryPermissionSet = false, isPermissionSetList = [], permissionList = [], userGroupPermissionName = "";

            if (func_validation.isObjectNotEmpty(value)) {
                userGroupId = func_validation.getObjectPropertyValue(value, "userGroupId");
                isEveryPermissionSet = func_validation.getObjectPropertyValue(value, "isEveryPermissionSet");
                isPermissionSetList = func_validation.getObjectPropertyValue(value, "isPermissionSetList");
                permissionList = func_validation.getObjectPropertyValue(value, "permissionList");
                userGroupPermissionName = func_validation.getObjectPropertyValue(value, "userGroupPermissionName");
            }

            return (!isSubrow)? (
                <div className={"permission-tableColumn-permission-cell d-flex align-items-center justify-content-center w-100"} key={key}>
                    {/* Main Checkbox */}
                    <FormCheckbox
                        isCheckboxCheckedDefault={isEveryPermissionSet}
                        
                        // isResetRequired={isResetRequired}
                        isCheckboxDisabled={func_validation.isUserAccessDenied(props, "Internal_Permission_Add") &&
                            func_validation.isUserAccessDenied(props, "Internal_Permission_Delete")}
            
                        handleCheckboxSelectionSub={(checkboxID, isChecked) => {
                            if (props.handleMainCheckboxSelection)
                                props.handleMainCheckboxSelection(isChecked, userGroupId, userGroupPermissionName);
                        }}
                        
                        isDecoration_lightBackground
                    />
                </div>
            ):(
                <div className={"permission-tableColumn-permission-cell-subrow w-100"} key={key}>
                    {/* Sub Checkbox */}
                    {func_validation.isArrayNotEmpty(isPermissionSetList)? isPermissionSetList.map((isPermissionSet, idx) => {
                        return (
                            <div className={"permission-tableColumn-permission-cell-subrowItem d-flex align-items-center justify-content-center"} key={idx}>
                                <FormCheckbox
                                    isCheckboxCheckedDefault={isPermissionSet}

                                    // isResetRequired={isResetRequired}
                                    isCheckboxDisabled={func_validation.isUserAccessDenied(props, "Internal_Permission_Add") &&
                                        func_validation.isUserAccessDenied(props, "Internal_Permission_Delete")}

                                    handleCheckboxSelectionSub={(checkboxID, isChecked) => {
                                        if (props.handleSubCheckboxSelection)
                                            props.handleSubCheckboxSelection(isChecked, userGroupId, permissionList[idx]);
                                    }}

                                    isDecoration_lightBackground
                                />
                            </div>
                        )
                    }):""}
                </div>
            );
        },
    }
}